/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:de8c7c51-2cbe-41bb-b7bc-5bdf351a4494",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_O6N3mB3rz",
    "aws_user_pools_web_client_id": "32r44pem39sjnmu7ct7hou51i0",
    "oauth": {}
};


export default awsmobile;
